import React from "react";

import { GradientDefs } from "../../GradientDefs";

/**
 * @component TaskListAddIcon
 * @description
 *
 * The React Icon component is a visual element that displays an icon to represent a concept, object, or action.
 * The Icon component is
 * customizable, allowing for variations in size, color, and style to fit the needs of the application.
 *
 * @prop {string} [gradient] - Optional CSS linear-gradient string to apply a custom fill.
 * Format: "linear-gradient(<angle>deg, <color1>, <color2>, ...)"
 *
 * @example
 * return (
 * <TaskListAddIcon gradient="linear-gradient(135deg, #4da2ed, #f72222)" />
 * )
 *
 * @example
 * return (
 *   <TaskListAddIcon className="mr-2" />
 * )
 *
 * @see
 * https://system.activecollab.com/?path=/story/foundation-icons-icons--icons
 * @see
 * https://design.activecollab.com/docs/foundations/icons
 */
const TaskListAddIcon = React.forwardRef(
  (
    {
      gradient,
      ...props
    }: React.SVGProps<SVGSVGElement> & {
      gradient?: string;
    },
    ref?: React.Ref<SVGSVGElement>
  ) => (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      width={24}
      height={24}
      viewBox="0 0 24 24"
      data-testid="TaskListAddIcon"
      fill={
        gradient
          ? "url(#icon-gradient)"
          : props?.fill
          ? props.fill
          : "var(--color-theme-600)"
      }
      focusable={false}
      ref={ref}
      {...props}
    >
      <GradientDefs gradient={gradient} />
      <path
        fillRule="evenodd"
        d="M20 14v3h3v2h-3v3h-2v-3h-3v-2h3v-3zm-8 4a1 1 0 0 1 0 2H5a1 1 0 0 1 0-2zm0-4a1 1 0 0 1 0 2H5a1 1 0 0 1 0-2zm7-4a1 1 0 0 1 0 2H5a1 1 0 0 1 0-2zm0-6a1 1 0 0 1 1 1v2a1 1 0 0 1-1 1H5a1 1 0 0 1-1-1V5a1 1 0 0 1 1-1z"
      />
    </svg>
  )
);
TaskListAddIcon.displayName = "TaskListAddIcon";
export default TaskListAddIcon;
